import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TASKLISTDETAIL,
  DELETE_TASKLISTDETAIL,
  UPDATE_TASKLISTDETAIL,
  ADD_NEW_TASKLISTDETAIL,
} from "./actionType";

import {
  getTaskListDetailSuccess,
  getTaskListDetailFail,
  deleteTaskListDetailSuccess,
  deleteTaskListDetailFail,
  updateTaskListDetailSuccess,
  updateTaskListDetailFail,
  addTaskListDetailSuccess,
  addTaskListDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveTaskListDetailApi,
  getTaskListDetailApi,
  updateTaskListDetailApi,
  deleteTaskListDetailApi,
  addNewTaskListDetailApi
} from "../../helpers/backend_helper";

function* getTaskListDetail({ payload: taskListDetail }) {
  try {
    const response = yield call(getTaskListDetailApi, taskListDetail);
    yield put(getTaskListDetailSuccess(GET_TASKLISTDETAIL, response.data));
  } catch (error) {
    yield put(getTaskListDetailFail(GET_TASKLISTDETAIL, error));
  }
}

function* onUpdateTaskListDetail({ payload: taskListDetail }) {
  try {
    if (taskListDetail.setApprove) {
      const response = yield call(approveTaskListDetailApi, taskListDetail);
      yield put(updateTaskListDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateTaskListDetailApi, taskListDetail);
      yield put(updateTaskListDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTaskListDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTaskListDetail({ payload: taskListDetail }) {
  try {
    const response = yield call(deleteTaskListDetailApi, taskListDetail);
    yield put(deleteTaskListDetailSuccess({ taskListDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTaskListDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTaskListDetail({ payload: taskListDetail }) {
  try {
    const response = yield call(addNewTaskListDetailApi, taskListDetail);
    yield put(addTaskListDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTaskListDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTaskListDetail() {
  yield takeEvery(GET_TASKLISTDETAIL, getTaskListDetail);
}

export function* watchUpdateTaskListDetail() {
  yield takeEvery(UPDATE_TASKLISTDETAIL, onUpdateTaskListDetail);
}

export function* watchDeleteTaskListDetail() {
  yield takeEvery(DELETE_TASKLISTDETAIL, onDeleteTaskListDetail);
}

export function* watchAddNewTaskListDetail() {
  yield takeEvery(ADD_NEW_TASKLISTDETAIL, onAddNewTaskListDetail);
}

function* taskListDetailSaga() {
  yield all([
    fork(watchGetTaskListDetail),
    fork(watchDeleteTaskListDetail),
    fork(watchUpdateTaskListDetail),
    fork(watchAddNewTaskListDetail)
  ]);
}

export default taskListDetailSaga;
